module.exports = __webpack_public_path__ + "img/KQ.e24f212d.png";